/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useState, useContext, useEffect, useCallback } from 'react'
import {
  unitIdHeader,
  modifierCol,
  modifiedDateCol,
  utilityHeader,
} from 'core/HeaderColTypeProps'
import { strCol, numCol } from '@integec/grid-tools/lib/cols'
import { getCard97ExtensionSpec, getCustomCard97Data } from 'api/pgads'
import { connect } from 'react-redux'
import { getApiTargetInfo, getUnitNameMap, getUtilityNameMap } from 'core'
import { ErrorContext } from 'context'
import CommonScreen from 'admin/component/CommonScreen'
import { InputNumber } from 'antd'
import moment from 'moment'

const title = 'Custom Card97 Data'

const CustomCard97 = ({ targetInfo, utilityNameMap, unitNameMap }) => {
  const [year, setYear] = useState(moment().format('YYYY'))
  const { setError } = useContext(ErrorContext)
  const [extensionSpec, setExtensionSpec] = useState()

  useEffect(
    _ => {
      getCard97ExtensionSpec(targetInfo).fork(setError, spec =>
        setExtensionSpec(spec[0])
      )
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  const getDynamicHeaderName = h => {
    if (h && h !== 'N\\A') return h
    return null
  }

  const headers = useCallback(() => {
    const dynamicColumns = []
    if (extensionSpec) {
      for (let i = 1; i <= 8; i++) {
        const currHeader = getDynamicHeaderName(extensionSpec['header' + i])

        if (currHeader) {
          dynamicColumns.push(
            i < 4
              ? numCol({
                  ident: 'number' + i,
                  display: currHeader,
                  // displayFormat: '0',
                  sortOrder: 'asc',
                  width: 150,
                })
              : strCol({
                  ident: 'string' + i,
                  display: currHeader,
                  sortOrder: 'asc',
                  width: 150,
                })
          )
        }
      }
    }

    return [
      utilityHeader,
      unitIdHeader,
      numCol({
        ident: 'year',
        display: 'Year',
        displayFormat: '0',
        isKey: true,
        sortOrder: 'desc',
      }),
      numCol({
        ident: 'eventNum',
        display: 'EVENTNUM',
        displayFormat: '0',
        isKey: true,
        width: 150,
      }),
      strCol({
        ident: 'eventType',
        display: 'Event Type',
        sortOrder: 'asc',
        width: 150,
      }),
      numCol({
        ident: 'causeCode',
        display: 'Cause Code',
        displayFormat: '0',
        sortOrder: 'asc',
        width: 150,
      }),
      ...dynamicColumns,
      strCol({
        ident: 'description',
        display: 'Description',
        sortOrder: 'asc',
        width: 300,
        ellipsis: true,
        alignment: 'left',
      }),
      modifierCol,
      modifiedDateCol,
    ]
  }, [extensionSpec])

  const withCriteria = (state, props, selectedUnits) => ({
    year,
    units: (selectedUnits || []).filter(e => !!e).map(e => e.unitId),
  })

  const screenCriteria = (s, p, u, onChange) => {
    return (
      <InputNumber
        style={{ width: '100px' }}
        value={year}
        onChange={year => {
          setYear(year)
          onChange()
        }}
      />
    )
  }

  const headerWithFormatter = useCallback(
    _ =>
      headers().map(header =>
        header.ident === 'utility'
          ? {
              ...header,
              dataFormatter: ({ value }) => utilityNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                utilityNameMap[rowData.utility] || rowData.utility,
            }
          : header.ident === 'unitId'
          ? {
              ...header,
              // choices: [],
              dataFormatter: ({ value }) => unitNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                unitNameMap[rowData.unit] || rowData.unit,
            }
          : header
      ),
    [headers, utilityNameMap, unitNameMap]
  )

  return (
    <CommonScreen
      withoutModify
      withUnitSelection
      autoRetrieve={false}
      allowInsert={false}
      title={title}
      header={headerWithFormatter()}
      retrieveTask={getCustomCard97Data}
      screenCriteria={screenCriteria}
      withCriteria={withCriteria}
      altBy={u => u.unitId}
      sortOptions={headerWithFormatter()}
      initialSortOptions={headerWithFormatter()}
      widthOffset={50}
      isEditableGrid={() => false}
      isAdminScreen={false}
    />
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
})

export default connect(mapStateToProps)(CustomCard97)
